import { Button, Icon } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { handleRedirectSignIn } from '@hero/utils';

import * as S from './style';

function SignUpRedirect() {
  const { t } = useTranslation();

  return (
    <S.SignUpRedirect>
      <S.SignUpRedirectIcon>
        <Icon name="success" size={48} color={'var(--color-accent-primary-default)'} />
      </S.SignUpRedirectIcon>
      <S.SignUpRedirectBody>
        <S.SignUpRedirectText>{t('congratulations')}</S.SignUpRedirectText>
        <S.SignUpRedirectText>{t('signUpCongrats')}</S.SignUpRedirectText>
      </S.SignUpRedirectBody>
      <Button color="primary" onClick={() => handleRedirectSignIn()}>
        {t('signIn')}
      </Button>
    </S.SignUpRedirect>
  );
}

export { SignUpRedirect };
